import React from 'react';
import { useState, useEffect, useContext } from 'react';
import { Button, Grid } from '@mui/material';

import '../css/NotFoundComponent.scss'
import UserContext from './User_Context';

import notFoundLarge from '../imgs/Type=404, Size=extra large.svg'
import notFoundSmall from '../imgs/Type=404, Size=extra small.svg'
import notFoundLargeContrast from '../imgs/Type=Contrast 404, Size=extra large.svg'
import notFoundSmallContrast from '../imgs/Type=Contrast 404, Size=extra small.svg'
import ArrowIcon from '../imgs/Size=Small, Type=flecha back.svg'
import ArrowIconContrast from '../imgs/Size=Small, Type=flecha back contrast.svg'

function NotFoundComponent() {

  const userContext = useContext(UserContext);
  const [contrast, setContrast] = useState(false);

  useEffect(() => {
    setContrast(userContext.contrast)
  }, [userContext]);

  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
    window.innerHeight,
  ]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  });

  function ChooseSize(windowSize) {

    if (windowSize[0] <= 1199) {
      console.log(windowSize[0])
      return contrast ? notFoundSmallContrast : notFoundSmall;
    }
    return contrast ? notFoundLargeContrast : notFoundLarge;
  }

  return (
    <Grid container className={`not-found-grid ${contrast ? "high-not-found-grid" : ""}`} >  
      <img className='notFound-img' src={ChooseSize(windowSize)} alt="Página não encontrada" />
      <Button className='return-home-button' sx={{ textTransform: 'none' }} href='/'>
        <img src={userContext.contrast ? ArrowIconContrast : ArrowIcon} />
        Voltar à página inicial
      </Button>
    </Grid>
  );

}

export default NotFoundComponent;